import { configure } from '@/util/container';
import registerFocus from '@/util/focus';
import { VUE } from '..';

export default configure(async (get) => void registerFocus(await get(VUE)));
